"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="232341" className="flex flex-col gap-3">
        <div className="h-3 w-16 bg-primary/10 animate-pulse rounded-none" />
        <div className="h-3 w-20 bg-primary/10 animate-pulse rounded-none" />
        <div className="h-3 w-14 bg-primary/10 animate-pulse rounded-none" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-xs text-muted-foreground hover:text-primary transition-colors duration-300 font-mono uppercase tracking-wider">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function YeFooter() {
  const socialLinks = [];
  const legalLinks = [{
    label: "PRIVACY POLICY",
    href: "/privacy-policy/"
  }, {
    label: "TERMS OF SERVICE",
    href: "/terms-of-service/"
  }];
  return <section id="footer" className="dark bg-background text-foreground border-t border-border pt-16 pb-8 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 mb-24">
          {}
          <div className="col-span-2 md:col-span-1 flex items-start">
            <Link to="/">
              <img src="https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/ye_logo_white_minimal-e1777106674508.png" alt="Citizen Advocates Network" className="h-7 object-contain brightness-200 grayscale" />
            </Link>
          </div>

          {}
          <div className="col-span-1">
            <MenuProvider menu_id="48">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="col-span-1">
            <ul className="flex flex-col gap-3">
              {socialLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to="#" className="text-xs text-muted-foreground hover:text-primary transition-colors duration-300 font-mono uppercase tracking-wider">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="col-span-1">
            <ul className="flex flex-col gap-3">
              {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href || "#"} className="text-xs text-muted-foreground hover:text-primary transition-colors duration-300 font-mono uppercase tracking-wider">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="flex justify-start items-end">
          <p className="text-[12px] text-muted-foreground tracking-widest uppercase font-mono">
            © {new Date().getFullYear()} CITIZEN ADVOCATES NETWORK. DATA-DRIVEN GOVERNANCE.
          </p>
        </div>
      </div>
    </section>;
}